<div class="wrapper-container" [ngClass]="{'material-style': materialStyle}">  
    <label class="mat-caption se-floating-label"
           [ngClass]="{ 'disabled': state === 'disabled', 'error': state === 'error', 'warning': state === 'warning'}"
           [for]="for"
           [title]="tooltip ?? ''">
        <span class="line-behind"></span>
        <ng-content></ng-content>
    </label>
</div>
